import React from 'react';
import { useTranslation } from 'react-i18next';

// BARIS DIBAWAH INI DIHAPUS/DIKOMENTARI AGAR TIDAK ERROR
// import { fetchProjects } from '../../services/index'; 

export default function Portfolio() {
    const { t } = useTranslation();

    const projects = [
        {
            id: 1,
            title: "Xyrons Community Hub",
            desc: "Platform sosial untuk developer berbasis React & Node.js.",
            tech: ["React", "Vercel", "i18next"],
            link: "#"
        },
        {
            id: 2,
            title: "Chrono-Jumper",
            desc: "Game petualangan platformer dengan mekanik perjalanan waktu.",
            tech: ["JavaScript", "HTML5 Canvas"],
            link: "#"
        },
        {
            id: 3,
            title: "Xyrons Digital ID",
            desc: "Generator identitas pintar untuk ekosistem digital modern.",
            tech: ["Node.js", "Express"],
            link: "#"
        }
    ];

    return (
        <div style={styles.container}>
            <header style={styles.header}>
                <h1 style={styles.title}>{t('nav_portfolio') || 'PORTFOLIO'}</h1>
                <p style={styles.subtitle}>Kumpulan kreasi digital dan eksperimen terbaru saya.</p>
            </header>

            <div style={styles.grid}>
                {projects.map((project) => (
                    <div key={project.id} style={styles.card}>
                        <div style={styles.cardCover}>
                            <div style={styles.glowOverlay}></div>
                        </div>
                        <div style={styles.cardBody}>
                            <h3 style={styles.projectTitle}>{project.title}</h3>
                            <p style={styles.projectDesc}>{project.desc}</p>
                            <div style={styles.techStack}>
                                {project.tech.map((item, index) => (
                                    <span key={index} style={styles.tag}>{item}</span>
                                ))}
                            </div>
                            <a href={project.link} style={styles.btnLink}>Lihat Proyek →</a>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

const styles = {
    container: { padding: '80px 20px', maxWidth: '1200px', margin: '0 auto', color: '#fff', background: '#000', minHeight: '100vh' },
    header: { textAlign: 'center', marginBottom: '60px' },
    title: { fontSize: '40px', fontWeight: '900', color: '#00d2ff', textTransform: 'uppercase', letterSpacing: '6px' },
    subtitle: { color: '#666', marginTop: '15px', fontSize: '16px', letterSpacing: '1px' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '30px' },
    card: { background: '#0a0a0a', borderRadius: '28px', border: '1px solid #1a1a1a', overflow: 'hidden', transition: '0.3s ease' },
    cardCover: { height: '160px', background: 'linear-gradient(135deg, #00d2ff 0%, #005f73 100%)', position: 'relative' },
    glowOverlay: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.2)' },
    cardBody: { padding: '30px' },
    projectTitle: { fontSize: '24px', fontWeight: '800', marginBottom: '12px', color: '#fff' },
    projectDesc: { color: '#888', fontSize: '14px', lineHeight: '1.7', marginBottom: '25px', minHeight: '60px' },
    techStack: { display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '25px' },
    tag: { background: '#111', color: '#00ff88', padding: '6px 14px', borderRadius: '10px', fontSize: '11px', fontWeight: 'bold', border: '1px solid #222' },
    btnLink: { color: '#00d2ff', textDecoration: 'none', fontSize: '14px', fontWeight: '900', textTransform: 'uppercase' }
};